import { RealtimeRole } from '@doxyme/og-realtime';
import { dispatch } from './reducer';
import { SessionStorageActionTypes as ActionType } from './actionTypes';
const defaultKeys = [
    'referrer',
    'state',
    'rooms',
    'vendor',
    'navigationStarted',
    'roomId',
    'chatHistory',
    'identityId',
    'isAudioCall',
];
const patientKeys = [
    ...defaultKeys,
    'sessionId',
    'passcode',
    'role',
    'joinedParticipantsIds',
];
const providerKeys = [
    ...defaultKeys,
    'patientId',
    'role',
    'subscriptionType',
    'institutionsMembershipsIds',
    'institutionId',
    'profileInfo',
    'userId',
    'patientPlatform',
];
const getSessionStorageDataKeys = (data) => {
    if (!('role' in data)) {
        return defaultKeys;
    }
    switch (data.role) {
        case RealtimeRole.Provider:
            return providerKeys;
        case RealtimeRole.Patient:
            return patientKeys;
        default:
            return defaultKeys;
    }
};
export const filterObjectByKeys = (data, predicate) => {
    const returnObj = {};
    for (const key of Object.keys(data)) {
        if (predicate(key)) {
            returnObj[key] = data[key];
        }
    }
    return returnObj;
};
export const getApolloSessionStorageDataAction = (data) => {
    const filteredByKeys = filterObjectByKeys(data, (key) => getSessionStorageDataKeys(data).includes(key));
    const filteredNonEmptyStrings = filterObjectByKeys(filteredByKeys, (key) => filteredByKeys[key] !== '');
    return {
        type: ActionType.SET_APOLLO_SESSION_STORAGE_KEYS,
        payload: filteredNonEmptyStrings,
    };
};
export const setApolloSessionStorageData = (data) => dispatch(getApolloSessionStorageDataAction(data));
